<template>
  <keep-alive :max="5" exclude="CreateClass">
    <router-view :key="key"></router-view>
  </keep-alive>
</template>
<script>
export default {
  name: 'AppEmpty',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.path;
    }
  }
};
</script>
